import { render, staticRenderFns } from "./accounts.vue?vue&type=template&id=88a7fed6"
import script from "./accounts.vue?vue&type=script&lang=js"
export * from "./accounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports